// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1Tu6o","unreadBadge":"styles_unreadBadge__3_5fw","modalContent":"styles_modalContent__3kScO","modal":"styles_modal__YOIvX"};